import { a as containerShortcuts } from './shared/preset-wind3.BzmnsdqZ.mjs';
import '@unocss/core';
import '@unocss/preset-mini/utils';

const shortcuts = [
  ...containerShortcuts
];

export { shortcuts };
